import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const OutdoorBanners = () => {

    const servicesFaqData = [
        {
            question: "What materials are used for outdoor banners printing?",
            answer: "We use high-quality, weather-resistant materials such as vinyl and flex for Outdoor Flex Banner Printing. These materials ensure durability, making banners suitable for outdoor conditions like rain, wind, and sunlight."
        },
        {
            question: "Can Printingy handle bulk orders for outdoor banners?",
            answer: "Yes, Printingy specialises in bulk custom outdoor banner printing. Our efficient processes ensure consistent quality, cost savings, and timely delivery for large-scale promotional campaigns or events."
        },
        {
            question: "What industries benefit from outdoor banner printing services?",
            answer: "Our Outdoor Banners Printing services are widely used in retail, events, real estate, education, hospitality, and corporate advertising. Outdoor banners are perfect for product launches, festivals, exhibitions, and roadside promotions."
        },
        {
            question: "What customisation options are available for outdoor banners?",
            answer: "Printingy offers full customisation for outdoor banner design & printing, including size, graphics, colour schemes, and finishes. You can include logos, images, and messaging to suit your branding and promotional needs."
        },
        {
            question: "Are outdoor banners suitable for all weather conditions?",
            answer: "Yes, our outdoor banners are designed to withstand various weather conditions. With Outdoor Flex Banner Printing, we use weatherproof materials and UV-resistant inks to ensure durability and fade-free visuals."
        },
        {
            question: "How long does it take to print bulk outdoor banners?",
            answer: "The turnaround time for Outdoor Banners Printing services depends on the size and volume of the order. Standard bulk orders are completed within a few business days, and we prioritise on-time delivery."
        },
        {
            question: "Can I use outdoor banners for multiple events?",
            answer: "Absolutely. Our custom outdoor banner printing services provide durable, reusable banners that maintain their quality over time. These banners are easy to roll, store, and transport."
        },
        {
            question: "Do you offer design assistance for outdoor banners?",
            answer: "Yes, Printingy provides professional design support for outdoor banner design & printing. Whether you have an existing layout or need help creating a design, our team ensures sharp and visually impactful results."
        },
        {
            question: "What makes outdoor banners effective for advertising?",
            answer: "Outdoor banners offer high visibility, making them ideal for reaching large audiences. With custom outdoor banner printing, you can display clear messaging, vibrant visuals, and branding that attracts attention in outdoor settings."
        },
        {
            question: "How do I place an order for outdoor banners printing?",
            answer: "Placing an order is easy. Visit our website, select your preferences for Outdoor Banners Printing services, upload your artwork, and confirm your details. Our team handles the rest, ensuring a seamless process from design to delivery."
        }
    ];
    
    
    const [pageTitle, setPageTitle] = useState('Printing of Outdoor Banners');  // Dynamic title state

    useEffect(() => {
      document.title = pageTitle; // Set the document title dynamically
    }, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title="Custom Outdoor Banners Printing Services for Promotions"
  description="Professional outdoor banners printing services, including custom outdoor banner printing and outdoor flex banner printing. Durable outdoor banner design & printing for businesses."
  keywords="Outdoor Banners,
Outdoor Banners Printing services,
Outdoor Flex Banner Printing,
Custom Outdoor Banner Printing,
Outdoor Banner Design & Printing
"
/>


      <header className="services-header text-center py-5 serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Outdoor Banners Printing Services</h1>
              <h2 className="text-muted">
              Durable and custom outdoor banner design & printing solutions 
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Outdoor banners are a highly effective and durable tool for advertising, events, and promotions. Printingy specialises in Outdoor Banners Printing services, offering high-quality Outdoor Flex Banner Printing and custom outdoor banner printing tailored to meet your business needs.</p>
          <p>Our banners are designed to withstand harsh weather conditions, ensuring longevity and visual impact. With vibrant outdoor banner design & printing, we deliver sharp graphics, fade-resistant colours, and customised solutions that align with your branding requirements.</p>
          <p>Whether for product launches, corporate promotions, or outdoor events, Printingy guarantees cost-effective bulk printing and premium results that make your banners stand out.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3  rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Outdoor Banner Printing Solutions </h2>
                <h3 className="large-hed">High-quality, durable, and weatherproof banners for outdoor promotions</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Outdoor Banners Printing services for events and advertising.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional Outdoor Flex Banner Printing for sharp, vibrant visuals.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk custom outdoor banner printing for cost-effective large-scale orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable materials, fade-resistant, and weatherproof for long-term use.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully tailored outdoor banner design & printing to suit your branding needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology ensuring precision and vibrant graphics.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and urgent projects.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by businesses, event organisers, and outdoor advertisers nationwide.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/outdoorbanners.jpg" // Path relative to the public folder
                  alt="Custom outdoor banner printing solutions"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
      title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Outdoor Banners Delivered On Time</h2>
            <h3 className="small-hed">Focus on your branding while we manage your outdoor banner printing needs</h3>
            <p>At Printingy, we ensure superior quality and durability with our Outdoor Banners Printing services. Whether you need Outdoor Flex Banner Printing for promotions or custom outdoor banner printing for advertising campaigns, we deliver results that exceed expectations.</p>
            <p>Our streamlined process guarantees timely delivery for bulk orders while maintaining precision and consistency in every print. Partner with Printingy to create impactful outdoor banners that withstand weather conditions and elevate your brand visibility.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default OutdoorBanners;
